export default __webpack_public_path__ + "static/media/chester-wade.ac97a7f2.jpg";